import script from "./CollectMail.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectMail.vue?vue&type=script&setup=true&lang=js"

import "./CollectMail.vue?vue&type=style&index=0&id=1d207b6b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d207b6b"]])

export default __exports__